// extracted by mini-css-extract-plugin
export default {"root":"MapBlockContainer_root__2DXSc"};